import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';

import Headerblock from './HeaderBlock';

import './ToggleView.scss';

const withToggleView = (WrappedComponent, config) => props => {
  const [mode, setMode] = useState('view');

  const toggleMode = () => {
    setMode(mode === 'view' ? 'edit' : 'view');
  };

  const setViewMode = () => {
    setMode('view');
  };

  const strings = get(props, 'strings');
  const id = get(props, 'id');
  const { name, active, title, defaultTitle } = { active: true, ...config };

  return (
    <div className={`block-toggle-view ${name}`}>
      <Headerblock
        title={strings[title] || defaultTitle}
        mode={mode}
        id={id}
        toggleMode={toggleMode}
        strings={strings}
        active={active}
      />
      <WrappedComponent mode={mode} setViewMode={setViewMode} {...props} />
    </div>
  );
};

withToggleView.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string),
  // eslint-disable-next-line react/forbid-prop-types
  party: PropTypes.object,
};

withToggleView.defaultProps = {
  party: {},
  strings: {},
};

export default withToggleView;
